import Layout from '@/page/index/'

export default [
	// ===== 以下是存在的有效路由 =====

	// 投保中心支付
	{
		path: '/insuranceCenter',
		component: Layout,
		redirect: '/insuranceCenter/pay/payOffline',
		children: [
			{
				path: 'pay/payOffline',
				name: '对公支付',
				meta: {
					keepAlive: true,
				},
				component: () => import('@/views/insuranceCenter/pay/payOffline'),
			},
		],
	},

	// 渠道信息-分销渠道
	{
		path: '/channel',
		component: Layout,
		redirect: '/channel/list/listAdd',
		children: [
			{
				path: '/list/listAdd',
				name: '分销渠道',
				meta: {
					keepAlive: true,
				},
				component: () => import('@/views/channel/list/listAdd'),
			},
		],
	},

	// 数据管理-刷新列表
	{
		path: '/insurance',
		component: Layout,
		redirect: '/insurance/refresh',
		children: [
			{
				path: '/refresh',
				name: '更新数据',
				component: () => import('@/views/insurance/refresh'),
			},
		],
	},
]
